import { collection, doc } from 'firebase/firestore';
import { db } from './firebase.utils';

export const TRANSACTIONS_COLLECTION = 'transactions';

export const transactionsCollection = (uid) =>
  collection(db, 'users', uid, TRANSACTIONS_COLLECTION);

export const transactionDoc = (uid, id) =>
  doc(db, 'users', uid, TRANSACTIONS_COLLECTION, id);
